import {batchRequestToPublisher} from "publisher/communication/batchRequestToPublisher";

export async function saveScoToPublisher( serverURL, sco ) {

    const changedData = sco.getChangedData();
    if( changedData.size === 0 ){
        return Promise.resolve();
    }

    const lmsQueries = [];
    lmsQueries.push( `${serverURL}/initialize/${sco.getId()}` );
    for (const [key, value] of changedData) {
        lmsQueries.push( `${serverURL}/set-value?key=${key}&value=${encodeURIComponent(value)}` );
    }
    lmsQueries.push( `${serverURL}/terminate` );

    return batchRequestToPublisher( lmsQueries );
}
